var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({ref:"textField",staticClass:"text-capitalize",attrs:{"dense":"","outlined":"","label":_vm.$t(_vm.label),"value":_vm.value,"rules":_vm.rules},on:{"keydown":_vm.blurWhenEnter}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }